import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import PaperAirplaneIcon from '@heroicons/react/outline/PaperAirplaneIcon';
import loadable from '@loadable/component';
import clsx from 'clsx';
import { Prompt } from 'react-router';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { memberToMentionConverter } from '../common/utils/composer';
import { getPostFieldValue } from '../common/utils/post';
import { ComposerControls } from '../Composer/components';
import { useComposer } from '../Composer/hooks/useComposer';
import { T, useI18n } from '../i18n';
const Composer = loadable(() => import('../Composer'), {
    resolveComponent: module => module.Composer,
    ssr: false,
});
const ComposerProvider = loadable(() => import('../Composer/ComposerProvider'), {
    resolveComponent: module => module.ComposerProvider,
    ssr: false,
});
export const ReplyEditor = forwardRef((props, ref) => {
    var _a;
    const { reply, cachedMentions } = props;
    const content = getPostFieldValue(reply, 'content') ||
        getPostFieldValue(reply, 'answer') ||
        '';
    return (_jsx(ComposerProvider, { content: content, embeds: reply === null || reply === void 0 ? void 0 : reply.embeds, mentions: (_a = reply === null || reply === void 0 ? void 0 : reply.mentions) === null || _a === void 0 ? void 0 : _a.map(memberToMentionConverter), cachedMentions: cachedMentions, children: _jsx(InnerReplyEditor, { ...props, ref: ref }, void 0) }, void 0));
});
export const InnerReplyEditor = forwardRef(({ onReply, onCancel, reply, isLoading }, ref) => {
    const intl = useI18n();
    const { editor, isTouched, state } = useComposer();
    const isNew = !reply;
    useEffect(() => {
        if (editor) {
            editor.setOptions({
                editorProps: {
                    handleKeyDown: (view, event) => {
                        if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
                            onReply(editor.getHTML(), editor);
                            return true;
                        }
                        return false;
                    },
                },
            });
        }
    }, [editor, onReply]);
    useImperativeHandle(ref, () => ({
        focus: () => {
            editor.commands.focus();
        },
    }));
    return (_jsxs("div", { style: { minHeight: '160px' }, className: clsx('relative shadow-sm border rounded-md p-2 border-line-subdued overflow-y-auto flex flex-col overflow-hidden', { 'my-2': !isNew }), children: [_jsx("div", { className: "grow flex flex-col", children: _jsx(Composer, {}, void 0) }, void 0), _jsx(ComposerControls, { action: _jsxs(_Fragment, { children: [typeof onCancel === 'function' && (_jsx(Button, { variant: "outline", size: "sm", onClick: () => onCancel(isTouched), className: "me-1 sm:me-2", children: _jsx(T, { id: "Generics.Cancel", defaultMessage: "Cancel" }, void 0) }, void 0)), _jsx(Button, { loading: isLoading || state.loading, size: "sm", variant: "primary", onClick: () => onReply(editor.getHTML(), editor), children: _jsx("span", { className: "transform rotate-90 rtl:-rotate-90", children: _jsx(PaperAirplaneIcon, { className: "w-4 h-4" }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0), _jsx(Prompt, { when: isTouched, message: () => intl.$t({
                    id: 'Reply.ReplyEditor.EditorDirtyPromptText',
                    defaultMessage: 'Changes you made may not be saved.',
                }) }, void 0)] }, void 0));
});
//# sourceMappingURL=ReplyEditor.js.map